/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import ProgressCircular from './ProgressCircular';

Vue.component('ui-progress-circular', ProgressCircular);

